export default __webpack_public_path__ + "static/media/MaskGroup339.59ca2eea.png";